export interface CompareData {
  result_number: number | null;
  token_usage: { total?: { input?: number; output?: number; total?: number }; per_archive?: Record<string, any> } | null;
  config_labels: { llm?: string; ocr?: string; use_multimodal?: boolean };
  archives: Record<string, { kv_data: Record<string, any>; avg_confidence: number | null; field_count: number; is_classification?: boolean }>;
  stats: { total_fields: number; avg_confidence: number | null; archives_count: number };
  field_similarities?: Record<string, number>;
}

export type PathSegment = string | number;

export const RESULT_COLORS = [
  { bg: '#ff009acc', border: '#ff009a' },
  { bg: '#4f8ef7cc', border: '#4f8ef7' },
  { bg: '#24c58ccc', border: '#24c58c' },
  { bg: '#f0b429cc', border: '#f0b429' },
  { bg: '#a78bfacc', border: '#a78bfa' },
  { bg: '#fb923ccc', border: '#fb923c' },
];

export interface CompareContext {
  dataList: CompareData[];
  resultIds: string[];
  referenceResultId: string;
  allArchives: string[];
  labelFor: (index: number) => string;
  colorFor: (index: number) => { bg: string; border: string };
  translate: (key: string) => string;
}
